module.exports = __webpack_public_path__ + "img/LGGJLogo.97ddead4.jpg";